import { useForm, useFieldArray } from "react-hook-form";
import { IPerfilForm, IPerfilFormRHF } from "../../../types/perfil";
import { Perfil } from "../../../services/Perfil";
import { useNavigate } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { useCallback, useEffect, useState } from "react";

export const useProfilesRegister = () => {
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();
  const [recursos, setRecursos] = useState([] as string[]);
  const { register, handleSubmit, control } = useForm<IPerfilFormRHF>({
    defaultValues: {
      nome: "",
      nomeRecursos: [],
    },
  });

  const { append, remove, fields } = useFieldArray({
    control,
    name: "nomeRecursos",
  });

  const getRecursos = useCallback(() => {
    Perfil.getRecursos()
      .then(({ data }) => {
        setRecursos(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, []);

  function handleChangeItem(value: string) {
    const hasItem = fields.findIndex((i) => i.value === value);
    if (hasItem >= 0) {
      remove(hasItem);
      return;
    }
    append({ value });
  }

  function handleSubmitForm(data: IPerfilFormRHF) {
    setIsLoad(true);

    const PAYLOAD: IPerfilForm = {
      nome: data.nome,
      nomeRecursos: data?.nomeRecursos?.map((r) => r.value),
    };

    Perfil.post(PAYLOAD)
      .then(() => {
        toast.success("Perfil criado com sucesso!");
        navigate("/configuracoes/perfis");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    getRecursos();
  }, []);

  return {
    register,
    handleSubmit,
    handleChangeItem,
    handleSubmitForm,
    recursos,
    fields,
  };
};
